import { post } from '@tencent/pmd-network';
import { GoodsConfigInfo } from '@tencent/pmd-config/lib/goods';
import { initEnv } from '@tencent/pmd-tools/lib/env';
import { getConfig } from '@tencent/pmd-config';
import { QueryRoleListClient } from 'src/api/git.woa.com/itrpcprotocol/pmdtrpc/commcgi/tipcgi/tipcgi/QueryRoleList.http';

const getAppMainRole = async function () {
  try {
    const [response] = await QueryRoleListClient.QueryRoleList({ gid: 331 });

    if (response.role) {
      const Role = {};
      Role.role_base_info = response.role;

      if (response.gzone_name) {
        Role.gzone_name = response.gzone_name;
      }

      if (response.lader_info) {
        Role.role_base_info.gopenid = response.lader_info.gopenid;
        Role.role_base_info.lader_text = response.lader_info.lader_text;
        Role.role_base_info.lader = response.lader_info.lader;
        Role.role_base_info.lader_score = response.lader_info.lader_score;
      }

      return Promise.resolve(Role);
    }
    return Promise.reject();
  } catch (error) {
    return Promise.reject(error);
  }
};
/**
 * 获取主角色
 */
const getCurrentRole = function () {
  return new Promise((resolve, reject) => {
    post({
      url: GoodsConfigInfo.instance.queryRoleListUrl || '/pvp/comm/user/get_role_list',
      oldCGI: true,
      reqData: {
        gid: app.tip_gid || getConfig('game.gid'),
      },
      showMsgToast: false,
    })
      .then((response) => {
        let mainRole = {};
        if (response.role_info && response.role_info.RoleList && response.role_info.RoleList.length > 0) {
          const plat = initEnv().isIos ? 1 : (initEnv().isAndroid ? 2 : 0);
          for (let i = 0; i < response.role_info.RoleList.length; i++) {
            const role = response.role_info.RoleList[i].role_base_info;
            if (plat === role.device) {
              mainRole = role;
              break;
            }
          }
        }

        if (!mainRole || !mainRole.roleidx) {
          if (response.role_info.Role
            && response.role_info.Role.role_base_info
            && response.role_info.Role.role_base_info.roleidx) {
            mainRole = response.role_info.Role.role_base_info;
          } else if (response.role_info && response.role_info.RoleList && response.role_info.RoleList.length > 0) {
            mainRole = response.role_info.RoleList[0].role_base_info;
          }
        }

        resolve(mainRole);
      })
      .catch((error) => {
        console.log(error);
        if (error.r === 19) {
          resolve({});
        } else {
          reject(error);
        }
      });
  });
};

export {
  getAppMainRole,
  getCurrentRole,
};
